import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiBriefcase , FiMessageSquare} from 'react-icons/fi';
import logo from '../../assets/images/logo1.png';

const menuItems = [
  // { path: '/dashboard/find-groups', icon: <FiUsers />, label: 'Find Groups' },
  // { path: '/dashboard/group-list', icon: <FiHome />, label: 'My Groups' },
  { path: '/dashboard/broker', icon: <FiBriefcase />, label: 'Broker' },
  { path: '/dashboard/support', icon: <FiMessageSquare />, label: 'Support' },

];

const sidebarVariants = {
  open: {
    width: '16rem',
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  },
  closed: {
    width: '5rem',
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  }
};

const menuItemVariants = {
  open: {
    opacity: 1,
    x: 0,
    transition: {
      x: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    opacity: 0,
    x: -50,
    transition: {
      x: { stiffness: 1000 }
    }
  }
};

function DashboardSidebar({ isOpen, setIsOpen }) {
  const location = useLocation();

  return (
    <motion.div
      variants={sidebarVariants}
      initial="closed"
      animate={isOpen ? "open" : "closed"}
      className="h-full bg-white shadow-lg"
    >
      <div className="flex flex-col h-full">
        <div className="p-4 flex items-center">
          <motion.div
            animate={isOpen ? "open" : "closed"}
            variants={{
              open: { opacity: 1, x: 0 },
              closed: { opacity: 0, x: -20 }
            }}
            className="text-xl font-bold text-gray-800"
          >
            {isOpen && <img src={logo} alt="LeadTrek" className="h-8" />}
          </motion.div>
        </div>

        <nav className="flex-1 px-4 py-4">
          <ul className="space-y-2">
            {menuItems.map((item) => (
              <motion.li
                key={item.path}
                variants={menuItemVariants}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Link
                  to={item.path}
                  className={`flex items-center p-3 rounded-lg transition-colors ${
                    location.pathname === item.path
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <span className="text-xl">{item.icon}</span>
                  {isOpen && (
                    <motion.span
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      className="ml-3"
                    >
                      {item.label}
                    </motion.span>
                  )}
                </Link>
              </motion.li>
            ))}
          </ul>
        </nav>
      </div>
    </motion.div>
  );
}

export default DashboardSidebar; 